import { Utils } from "core/utils";
import { HttpService } from "../http";


export class UserHttpService {

    static async login(body) {
        var service = new HttpService();
        var response = await service.post('/auth/login/', body);
        return response;
    }

    static async logout() {
        Utils.removeUserSession();
    };

    static async clearAuthentication() {
        
    };

    static async loadUser(id) {
        var service = new HttpService();
        var response = await service.get(`/auth/user/${id}/`, null);
        return response;
    }

    static async updateUser(id, body) {
        var service = new HttpService();
        var response = await service.put(`/auth/user/${id}/`, body);
        return response;
    }

    static async updateUserVerification(id, is_verified) {
        var service = new HttpService();
        var response = await service.patch(`/auth/user/${id}/update-verification/`, { is_verified });
        return response;
    }

    static async saveUser(body) {
        var service = new HttpService();
        var response;

        if (body.id) {
            var id = body.id;
            delete body["id"]
            delete body["user"]

            response = await service.put(`/auth/user/${id}/`, body);
        }
        else
            response = await service.post('/api/register/', body);
        return response;
    }

    static async registerSocial(body) {
        var service = new HttpService();
        var response;

        response = await service.post('/api/register/social/', body);
        return response;
    }

    static async loadProfile() {
        var service = new HttpService();
        var response = await service.get(`/auth/profile/me/`, null);
        return response;
    }

    static async saveProfile(body) {
        console.log("Saving profile For: " + body)
        var service = new HttpService();
        var response;
        response = await service.post(`/auth/profile/update/`, body);
        return response;
    }

    static async deleteProfile(password) {
        // Use fetch directly since DELETE with body needs special handling
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        const auth = HttpService.getToken();
        if (auth) headers.append("Authorization", "Bearer " + auth);
        
        const response = await fetch(`${HttpService.ApiBase}/auth/profile/me/`, {
            method: 'DELETE',
            headers: headers,
            body: JSON.stringify({ password })
        });
        
        if (response.status === 401) {
            Utils.removeUserSession();
            console.log("401 Error at delete profile request");
        }
        
        const data = await response.json().catch(() => ({}));
        
        if (!response.ok) {
            throw { response: { data, status: response.status } };
        }
        
        return data;
    }

    static async updateProfileImage(body) {
        const formData = new FormData();
        formData.append("first_name", body.first_name);
        formData.append("last_name", body.last_name);

        if (body.file) formData.append("image", body.file, body.file.name);

        var service = new HttpService();
        var response;
        response = await service.post(`/auth/profile/update/`, formData, true);
        return response;
    }


    static async doLogin(user) {
        let body = {
            email: user.email,
            password: user.password,
        };

        var service = new HttpService();
        var response;
        response = await service.post(`/auth/login/`, body);

        // console.log(response)

        return response;
    }

    static async registerParticipant(body) {
        var service = new HttpService();
        var response;

        response = await service.post('/api/registerparticipant/', body);
        return response;
    }

    static async register(body) {
        var service = new HttpService();
        var response;

        response = await service.post('/auth/register/', body);
        return response;
    }

    static async resendVerificationEmail(body) {
        var service = new HttpService();
        var response;

        response = await service.post('/auth/resendverificationemail/', body);
        return response;
    }

    // Certificate endpoints
    static async getCertification(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/certificate/${id}`);
        return response;
    }

    static async createCertification(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/certificate/', data);
        return response;
    }

    static async updateCertification(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/certificate/${id}`, data);
        return response;
    }

    static async deleteCertification(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/certificate/${id}`);
        return response;
    }

    static async listCertifications() {
        var service = new HttpService();
        var response = await service.get('/job/cv/certificate/');
        return response;
    }

    // Skill endpoints
    static async getSkill(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/userskill/${id}`);
        return response;
    }

    static async addSkill(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/userskill/', data);
        return response;
    }

    static async updateSkill(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/userskill/${id}`, data);
        return response;
    }

    static async deleteSkill(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/userskill/${id}`);
        return response;
    }

    static async listSkills(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/userskill/?cv=${cvId}` 
            : '/job/cv/userskill/';
        var response = await service.get(url);
        return response;
    }

    // Education endpoints
    static async getEducation(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/education/${id}`);
        return response;
    }

    static async createEducation(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/education/', data);
        return response;
    }

    static async updateEducation(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/education/${id}`, data);
        return response;
    }

    static async deleteEducation(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/education/${id}`);
        return response;
    }

    static async listEducations(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/education/?cv=${cvId}` 
            : '/job/cv/education/';
        var response = await service.get(url);
        return response;
    }

    // Language endpoints
    static async getLanguage(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/userlanguage/${id}`); 
        return response;
    }

    static async createLanguage(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/userlanguage/', data);
        return response;
    }

    static async updateLanguage(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/userlanguage/${id}`, data);
        return response;
    }   

    static async deleteLanguage(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/userlanguage/${id}`);
        return response;
    }   

    static async listLanguages(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/userlanguage/?cv=${cvId}` 
            : '/job/cv/userlanguage/';
        var response = await service.get(url);
        return response;
    }   

    // Reference endpoints
    static async getReference(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/reference/${id}`); 
        return response;
    }

    static async createReference(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/reference/', data);
        return response;
    }

    static async updateReference(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/reference/${id}/`, data);
        return response;
    }

    static async deleteReference(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/reference/${id}`);
        return response;
    }

    static async listReferences(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/reference/?cv=${cvId}` 
            : '/job/cv/reference/';
        var response = await service.get(url);
        return response;
    }

    // Award endpoints
    static async getAward(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/award/${id}`); 
        return response;
    }

    static async createAward(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/award/', data);
        return response;
    }

    static async updateAward(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/award/${id}`, data);
        return response;
    }

    static async deleteAward(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/award/${id}`);
        return response;
    }

    static async listAwards(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/award/?cv=${cvId}` 
            : '/job/cv/award/';
        var response = await service.get(url);
        return response;
    }

    // Job Experience endpoints
    static async getJobExperience(id) {
        var service = new HttpService();
        var response = await service.get(`/job/cv/jobexperience/${id}`); 
        return response;
    }

    static async createJobExperience(data) {
        var service = new HttpService();
        var response = await service.post('/job/cv/jobexperience/', data);
        return response;
    }

    static async updateJobExperience(id, data) {
        var service = new HttpService();
        var response = await service.put(`/job/cv/jobexperience/${id}`, data);
        return response;
    }

    static async deleteJobExperience(id) {
        var service = new HttpService();
        var response = await service.delete(`/job/cv/jobexperience/${id}`);
        return response;
    }

    static async listJobExperiences(cvId = null) {
        var service = new HttpService();
        const url = cvId 
            ? `/job/cv/jobexperience/?cv=${cvId}` 
            : '/job/cv/jobexperience/';
        var response = await service.get(url);
        return response;
    }
}

